import * as i0 from '@angular/core';
import { Pipe, NgModule, Optional, Injectable } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule, CurrencyPipe } from '@angular/common';
import * as i2 from '@ngx-translate/core';
import * as i1$1 from '@eui/core';

/*
 * Example use
 *		Basic Array of single type: *ngFor="#todo of ttodoServiceodoService.todos | orderBy : '-'"
 *		Multidimensional Array Sort on single column: *ngFor="#todo of todoService.todos | orderBy : ['-status']"
 *		Multidimensional Array Sort on multiple columns: *ngFor="#todo of todoService.todos | orderBy : ['status', '-title']"
 */
class UxOrderByPipe {
    static _orderByComparator(a, b) {
        if ((isNaN(parseFloat(a)) || !isFinite(a)) || (isNaN(parseFloat(b)) || !isFinite(b))) {
            // Isn't a number so lowercase the string to properly compare
            if (a.toLowerCase() < b.toLowerCase()) {
                return -1;
            }
            if (a.toLowerCase() > b.toLowerCase()) {
                return 1;
            }
        }
        else {
            // Parse strings as numbers to compare properly
            if (parseFloat(a) < parseFloat(b)) {
                return -1;
            }
            if (parseFloat(a) > parseFloat(b)) {
                return 1;
            }
        }
        return 0; // equal each other
    }
    transform(input, [config = '+']) {
        if (!Array.isArray(input)) {
            return input;
        }
        if (!Array.isArray(config) || (Array.isArray(config) && config.length === 1)) {
            let propertyToCheck = !Array.isArray(config) ? config : config[0];
            let desc = propertyToCheck.substr(0, 1) === '-';
            // Basic array
            if (!propertyToCheck || propertyToCheck === '-' || propertyToCheck === '+') {
                return !desc ? input.sort() : input.sort().reverse();
            }
            else {
                let property = propertyToCheck.substr(0, 1) === '+' || propertyToCheck.substr(0, 1) === '-'
                    ? propertyToCheck.substr(1)
                    : propertyToCheck;
                return input.sort(function (a, b) {
                    return !desc
                        ? UxOrderByPipe._orderByComparator(a[property], b[property])
                        : -UxOrderByPipe._orderByComparator(a[property], b[property]);
                });
            }
        }
        else {
            // Loop over property of the array in order and sort
            return input.sort(function (a, b) {
                for (let i = 0; i < config.length; i++) {
                    let desc = config[i].substr(0, 1) === '-';
                    let property = config[i].substr(0, 1) === '+' || config[i].substr(0, 1) === '-'
                        ? config[i].substr(1)
                        : config[i];
                    let comparison = !desc
                        ? UxOrderByPipe._orderByComparator(a[property], b[property])
                        : -UxOrderByPipe._orderByComparator(a[property], b[property]);
                    // Don't return 0 yet in case of needing to sort by next property
                    if (comparison !== 0) {
                        return comparison;
                    }
                }
                return 0; // equal each other
            });
        }
    }
}
/** @nocollapse */ UxOrderByPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxOrderByPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
/** @nocollapse */ UxOrderByPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxOrderByPipe, name: "uxOrderBy", pure: false });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxOrderByPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'uxOrderBy', pure: false }]
        }] });
class UxOrderByPipeModule {
}
/** @nocollapse */ UxOrderByPipeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxOrderByPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxOrderByPipeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxOrderByPipeModule, declarations: [UxOrderByPipe], imports: [CommonModule], exports: [UxOrderByPipe] });
/** @nocollapse */ UxOrderByPipeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxOrderByPipeModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxOrderByPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [UxOrderByPipe],
                    declarations: [UxOrderByPipe]
                }]
        }] });

class UxFilterPipe {
    // TODO: find out what this pipe ie exactly doing and what it's arguments should be?
    /**
     *
     * @param value
     * @param args
     */
    transform(value, args) {
        if (!value) {
            throw new Error('value of UxFilterPipe cannot be null.');
        }
        // if no arguments given just return the value
        if (!args[0]) {
            return value;
        }
        return value.filter((item) => {
            for (let key in item) {
                if ((typeof item[key] === 'string' || item[key] instanceof String)) {
                    if (item[key].indexOf(args) !== -1) {
                        return true;
                    }
                }
            }
        });
    }
}
/** @nocollapse */ UxFilterPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxFilterPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
/** @nocollapse */ UxFilterPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxFilterPipe, name: "uxFilter" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxFilterPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'uxFilter'
                }]
        }] });
class UxFilterPipeModule {
}
/** @nocollapse */ UxFilterPipeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxFilterPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxFilterPipeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxFilterPipeModule, declarations: [UxFilterPipe], imports: [CommonModule], exports: [UxFilterPipe] });
/** @nocollapse */ UxFilterPipeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxFilterPipeModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxFilterPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [UxFilterPipe],
                    declarations: [UxFilterPipe]
                }]
        }] });

class UxTruncatePipe {
    /**
     * Truncates the given text and place a trail in the end based on given limit
     * @param value the value that will be truncated
     * @param limit default value is 40
     * @param trail default is https://www.compart.com/en/unicode/U+2026
     */
    transform(value, limit = 40, trail = '\u2026') {
        if (value) {
            if (limit < 0) {
                limit *= -1;
                return value.length > limit ? trail + value.substring(value.length - limit, value.length) : value;
            }
            else {
                return value.length > limit ? value.substring(0, limit) + trail : value;
            }
        }
        return value;
    }
}
/** @nocollapse */ UxTruncatePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxTruncatePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
/** @nocollapse */ UxTruncatePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxTruncatePipe, name: "uxTruncate" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxTruncatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'uxTruncate'
                }]
        }] });
class UxTruncatePipeModule {
}
/** @nocollapse */ UxTruncatePipeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxTruncatePipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxTruncatePipeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxTruncatePipeModule, declarations: [UxTruncatePipe], imports: [CommonModule], exports: [UxTruncatePipe] });
/** @nocollapse */ UxTruncatePipeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxTruncatePipeModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxTruncatePipeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [UxTruncatePipe],
                    declarations: [UxTruncatePipe]
                }]
        }] });

class UxCurrencyPipe {
    constructor(currencyPipe, translateService) {
        this.currencyPipe = currencyPipe;
        this.translateService = translateService;
        this.locale = 'en-US';
        if (translateService) {
            // register locales
            this.locale = translateService.currentLang;
        }
    }
    /**
     *
     * @param value The number to be formatted as currency.
     * @param currencyCode The [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217) currency code,
     * such as `USD` for the US dollar and `EUR` for the euro.
     * @param display The format for the currency indicator. One of the following:
     *   - `code`: Show the code (such as `USD`).
     *   - `symbol`(default): Show the symbol (such as `$`).
     *   - `symbol-narrow`: Use the narrow symbol for locales that have two symbols for their
     * currency.
     * For example, the Canadian dollar CAD has the symbol `CA$` and the symbol-narrow `$`. If the
     * locale has no narrow symbol, uses the standard symbol for the locale.
     *   - String: Use the given string value instead of a code or a symbol.
     * For example, an empty string will suppress the currency & symbol.
     *   - Boolean (marked deprecated in v5): `true` for symbol and false for `code`.
     *
     * @param digitsInfo Decimal representation options, specified by a string
     * in the following format:<br>
     * <code>{minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}</code>.
     *   - `minIntegerDigits`: The minimum number of integer digits before the decimal point.
     * Default is `1`.
     *   - `minFractionDigits`: The minimum number of digits after the decimal point.
     * Default is `2`.
     *   - `maxFractionDigits`: The maximum number of digits after the decimal point.
     * Default is `2`.
     * If not provided, the number will be formatted with the proper amount of digits,
     * depending on what the [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217) specifies.
     * For example, the Canadian dollar has 2 digits, whereas the Chilean peso has none.
     * @param locale A locale code for the locale format rules to use.
     * When not supplied, uses the value of `LOCALE_ID`, which is `en-US` by default.
     * See [Setting your app locale](guide/i18n#setting-up-the-locale-of-your-app).
     */
    transform(value, currencyCode = 'EUR', display = 'symbol', digitsInfo = '1.2-2', locale) {
        // TODO: import locales to make sure that transform will not fail
        // TODO: handle Locales Horizontally for eUI 9 through i18nService
        try {
            return this.currencyPipe.transform(value, currencyCode, display, digitsInfo, locale || this.locale);
        }
        catch (e) {
            return this.currencyPipe.transform(value, currencyCode, display, digitsInfo, 'en-US');
        }
    }
}
/** @nocollapse */ UxCurrencyPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxCurrencyPipe, deps: [{ token: i1.CurrencyPipe }, { token: i2.TranslateService, optional: true }], target: i0.ɵɵFactoryTarget.Pipe });
/** @nocollapse */ UxCurrencyPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxCurrencyPipe, name: "uxCurrency" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxCurrencyPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'uxCurrency' }]
        }], ctorParameters: function () { return [{ type: i1.CurrencyPipe }, { type: i2.TranslateService, decorators: [{
                    type: Optional
                }] }]; } });
class UxCurrencyPipeModule {
}
/** @nocollapse */ UxCurrencyPipeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxCurrencyPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxCurrencyPipeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxCurrencyPipeModule, declarations: [UxCurrencyPipe], imports: [CommonModule], exports: [UxCurrencyPipe] });
/** @nocollapse */ UxCurrencyPipeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxCurrencyPipeModule, providers: [CurrencyPipe], imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxCurrencyPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [UxCurrencyPipe],
                    declarations: [UxCurrencyPipe],
                    providers: [CurrencyPipe]
                }]
        }] });

class UxIsoToCountryPipe {
    constructor(service) {
        this.service = service;
    }
    /**
     * Convert country ISO code to country name (in english)
     * @param value the iso code
     * @returns country name in English
     */
    transform(value) {
        return this.service.iso2country(value);
    }
}
/** @nocollapse */ UxIsoToCountryPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxIsoToCountryPipe, deps: [{ token: i1$1.UxTimezoneService }], target: i0.ɵɵFactoryTarget.Pipe });
/** @nocollapse */ UxIsoToCountryPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxIsoToCountryPipe, name: "uxIsoToCountry" });
/** @nocollapse */ UxIsoToCountryPipe.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxIsoToCountryPipe });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxIsoToCountryPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'uxIsoToCountry'
                }]
        }, {
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.UxTimezoneService }]; } });
class UxIsoToCountryPipeModule {
}
/** @nocollapse */ UxIsoToCountryPipeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxIsoToCountryPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxIsoToCountryPipeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxIsoToCountryPipeModule, declarations: [UxIsoToCountryPipe], imports: [CommonModule], exports: [UxIsoToCountryPipe] });
/** @nocollapse */ UxIsoToCountryPipeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxIsoToCountryPipeModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxIsoToCountryPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [UxIsoToCountryPipe],
                    declarations: [UxIsoToCountryPipe]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { UxCurrencyPipe, UxCurrencyPipeModule, UxFilterPipe, UxFilterPipeModule, UxIsoToCountryPipe, UxIsoToCountryPipeModule, UxOrderByPipe, UxOrderByPipeModule, UxTruncatePipe, UxTruncatePipeModule };
